/**
 * 二手车查博士-历史车况查询
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 查询历史车况订单详情
// GET api/v1/used_car/cbs_order
Mock.mock(/used_car\/cbs_order/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'balance': 10000, // 表示100元
    'car_info': {
      'brand_url': Mock.Random.dataImage('200x100'),
      'vin': 'WGYA1238373738473',
      'plate_number': '粤J86666',
      'car_model_name': '玛莎拉蒂GranCabrio2012款4.7L自动MC'
    },
    'type_info': [
      {
        'type_id': 1,
        'type_name': '维修版',
        'discount_price': 500,
        'original_price': 2000
      },
      {
        'type_id': 2,
        'type_name': '综合版(维修/碰撞)',
        'discount_price': 2000,
        'original_price': 4800
      }
    ]
  }
})

// 查博士下单接口(确认支付)
// POST api/v1/used_car/pay_cbs_order
Mock.mock(/used_car\/pay_cbs_order/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})
